import {
  Chat,
  MainContainer,
  Main,
  ChatNav,
  ChatMessage,
  ChatInputs,
  InputContainer,
  SenderMessage,
  ReceiveMessage,
  LockMsgDialog,
  BottomBtn,
  EmojiContainer,
  EmojiCategory,
  EmojiNavigator,
  EmojiSearch,
  EmojiSearchBox,
  EmojiNotFound,
} from "./style";
import { BiPaperPlane, BiSolidLockAlt } from "react-icons/bi";
import {
  FiPlus,
  FiMic,
  FiCamera,
  FiX,
  FiChevronDown,
  FiSearch,
  FiPhone,
  FiVideo,
  FiMoreVertical,
  FiChevronLeft,
} from "react-icons/fi";
import {
  PiPizza,
  PiSmiley,
  PiCar,
  PiSoccerBall,
  PiShapes,
  PiFlag,
  PiDiamond,
  PiHand,
  PiDog,
  PiKeyboard,
} from "react-icons/pi";
import {
  useState,
  useRef,
  useEffect,
  Key,
  SetStateAction,
  useCallback,
} from "react";
import axios from "axios";
import TextareaAutosize from "react-textarea-autosize";
import ReactPlayer from "react-player";
import ProfileModal from "../ModalComponent/ProfileModal";
import LoadingState from "../LoadingState";

interface Emoji {
  name: string | undefined;
  unicode: Key | null | undefined;
  slug: string;
  character: string;
  unicodeName: string;
  codePoint: string;
  group: string;
  subGroup: string;
}

interface MessageComponentProps {
  data: {
    image: string;
    userName: string;
    chatId: string;
    userId: string;
    conversationId: string;
  };
  closeChat: () => void;
  audioCallModal: () => void;
}

interface Message {
  sender: string;
  message: string;
  time: string;
  _id: string;
}

interface MessageData {
  conversations: Message[];
}

const MessageChat: React.FC<MessageComponentProps> = ({
  data,
  closeChat,
  audioCallModal,
}) => {
  const [message, setMessage] = useState("");
  const [showSendButton, setShowSendButton] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [searchEmojiQuery, setSearchEmojiQuery] = useState("");
  const [emojis, setEmojis] = useState<Emoji[]>([]);
  const [showEmoji, setShowEmoji] = useState(false);
  const [EmojiLoading, setEmojiLoading] = useState(false);

  const [smileyEmojiBtn, setSmileyEmojiBtn] = useState(true);
  const [peopleEmojiBtn, setPeopleEmojiBtn] = useState(false);
  const [animalEmojiBtn, setAnimalEmojiBtn] = useState(false);
  const [foodEmojiBtn, setFoodEmojiBtn] = useState(false);
  const [travelEmojiBtn, setTravelEmojiBtn] = useState(false);
  const [activitiesEmojiBtn, setActivitiesEmojiBtn] = useState(false);
  const [objectsEmojiBtn, setObjectsEmojiBtn] = useState(false);
  const [symbolsEmojiBtn, setSymbolsEmojiBtn] = useState(false);
  const [flagsEmojiBtn, setFlagsEmojiBtn] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  // const [volume, setVolume] = useState(1);
  // const playerRef = useRef<ReactPlayer | null>(null);
  const [loading, setLoading] = useState(false);

  const [initialMessageData, setInitialMessageData] = useState<MessageData>({
    conversations: [],
  });

  const storedToken = sessionStorage.getItem("token");
  const myChatId = sessionStorage.getItem("chatId");
  const token = `Bearer ${storedToken}`;
  const [newConversationId, setNewConversationId] = useState(
    data.conversationId
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const emojiSearchRef = useRef<HTMLInputElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const emojiContainerRef = useRef<HTMLDivElement>(null);

  const handleTextChange = (e: any) => {
    const text = e.target.value;
    // const modifiedText = text.charAt(0).toUpperCase() + text.slice(1);
    setMessage(text);
    setShowSendButton(text.length > 0);
    setShowEmoji(false);
    if (text.trim() === "") {
      setShowSendButton(false);
    }
  };

  // webhook needed here to send outgoing message to other user
  // use userId, userName, conversationId

  const handleSendMessage = useCallback(() => {
    const payload = {
      message: message,
      sender: myChatId,
    };

    axios
      .patch(
        `${process.env.REACT_APP_API_BASE_ENDPOINT}/sendmessage/${data.conversationId}`,
        payload,
        {
          headers: Authorization,
        }
      )
      .then((res: any) => {
        scrollToBottom();
        setShowSendButton(false);
        setMessage("");
        if (textareaRef.current) {
          textareaRef.current.focus();
        }
        setIsPlaying(true);
        setTimeout(() => {
          setIsPlaying(false);
        }, 1000);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }, [data, message, myChatId]);

  const handleKeyDown = (e: { key: string; preventDefault: () => void }) => {
    if (e.key === "Enter" && !isMobile()) {
      e.preventDefault();
      handleSendMessage();
    }
  };
  const isMobile = () => {
    return window.innerWidth <= 768;
  };

  // webhook needed here to get incoming message

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_ENDPOINT}/getMessage/${newConversationId}`,
        {
          headers: Authorization,
        }
      )
      .then((res: any) => {
        setInitialMessageData(res.data);
        scrollToBottom();
      })
      .catch((err: any) => {});
  }, [Authorization, data, newConversationId]);

  // useEffect(() => {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_BASE_ENDPOINT}/getMessage/${newConversationId}`,
  //       {
  //         headers: Authorization,
  //       }
  //     )
  //     .then((res: any) => {
  //       setInitialMessageData(res.data);
  //     })
  //     .catch((err: any) => {});
  // });

  // const toggleVolume = () => {
  //   if (playerRef.current) {
  //     setVolume(volume === 1 ? 0 : 1);
  //     playerRef.current.setVolume(volume);
  //   }
  // };

  const handleProfileModal = () => {
    setProfileModal(!profileModal);
  };

  useEffect(() => {
    scrollToBottom();

    const handleScroll = () => {
      setScrollPosition(scrollContainerRef.current?.scrollTop || 0);
    };

    if (scrollContainerRef.current) {
      scrollContainerRef.current.addEventListener("scroll", handleScroll);

      return () => {
        scrollContainerRef.current?.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const scrollToBottom = () => {
    scrollContainerRef.current?.scrollTo({
      top: scrollContainerRef.current?.scrollHeight || 0,
      behavior: "smooth",
    });
  };

  const apiKey = process.env.REACT_APP_API_EMOJI_API_KEY;

  useEffect(() => {
    const apiUrl = `https://emoji-api.com/emojis?access_key=${apiKey}`;
    setEmojiLoading(true);
    axios
      .get(apiUrl)
      .then((response: { data: SetStateAction<Emoji[]> }) => {
        setEmojis(response.data);
        setEmojiLoading(false);
      })
      .catch((error: any) => {
        console.error("Error fetching emojis:", error);
      });
  }, [apiKey]);

  const handleEmojiSearch = (e: {
    target: { value: SetStateAction<string> };
  }) => {
    setSearchEmojiQuery(e.target.value);
  };

  const filteredEmojis = emojis.filter((emoji) =>
    emoji.unicodeName.toLowerCase().includes(searchEmojiQuery.toLowerCase())
  );

  const getEmojisByCategory = (group: string) => {
    return emojis
      .filter((emoji) => emoji.group === group)
      .map((emoji) => emoji.character);
  };

  const smileyEmotion = getEmojisByCategory("smileys-emotion");
  const peopleBody = getEmojisByCategory("people-body");
  const animalsNature = getEmojisByCategory("animals-nature");
  const foodDrink = getEmojisByCategory("food-drink");
  const travelPlaces = getEmojisByCategory("travel-places");
  const activities = getEmojisByCategory("activities");
  const objects = getEmojisByCategory("objects");
  const symbols = getEmojisByCategory("symbols");
  const flags = getEmojisByCategory("flags");

  const handleEmojiClick = (emojiCharacter: SetStateAction<string>) => {
    setMessage((prevContent) => prevContent + emojiCharacter);
    setShowSendButton(true);
  };
  const handleEmojiClickSub = (emoji: string) => {
    const updatedValue = message + emoji;
    setMessage(updatedValue);
    setShowSendButton(true);
  };

  const handleEmojiVisibility = () => {
    setShowEmoji(true);
    if (textareaRef.current) {
      textareaRef.current.blur();
    }
    if (emojiSearchRef.current) {
      emojiSearchRef.current.focus();
    }
  };

  const handleEmojiCancelVisibility = () => {
    setShowEmoji(false);
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
    if (emojiSearchRef.current) {
      emojiSearchRef.current.blur();
    }
  };

  const handleOutsideClick = (e: MouseEvent) => {
    if (
      emojiContainerRef.current &&
      !emojiContainerRef.current.contains(e.target as Node)
    ) {
      handleEmojiCancelVisibility();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleEmojiSmiley = () => {
    setSmileyEmojiBtn(true);
    setPeopleEmojiBtn(false);
    setAnimalEmojiBtn(false);
    setFoodEmojiBtn(false);
    setTravelEmojiBtn(false);
    setActivitiesEmojiBtn(false);
    setObjectsEmojiBtn(false);
    setSymbolsEmojiBtn(false);
    setFlagsEmojiBtn(false);
    setSearchEmojiQuery("");
  };
  const handleEmojiPeople = () => {
    setSmileyEmojiBtn(false);
    setPeopleEmojiBtn(true);
    setAnimalEmojiBtn(false);
    setFoodEmojiBtn(false);
    setTravelEmojiBtn(false);
    setActivitiesEmojiBtn(false);
    setObjectsEmojiBtn(false);
    setSymbolsEmojiBtn(false);
    setFlagsEmojiBtn(false);
    setSearchEmojiQuery("");
  };
  const handleEmojiAnimal = () => {
    setSmileyEmojiBtn(false);
    setPeopleEmojiBtn(false);
    setAnimalEmojiBtn(true);
    setFoodEmojiBtn(false);
    setTravelEmojiBtn(false);
    setActivitiesEmojiBtn(false);
    setObjectsEmojiBtn(false);
    setSymbolsEmojiBtn(false);
    setFlagsEmojiBtn(false);
    setSearchEmojiQuery("");
  };
  const handleEmojiFood = () => {
    setSmileyEmojiBtn(false);
    setPeopleEmojiBtn(false);
    setAnimalEmojiBtn(false);
    setFoodEmojiBtn(true);
    setTravelEmojiBtn(false);
    setActivitiesEmojiBtn(false);
    setObjectsEmojiBtn(false);
    setSymbolsEmojiBtn(false);
    setFlagsEmojiBtn(false);
    setSearchEmojiQuery("");
  };
  const handleEmojiTravel = () => {
    setSmileyEmojiBtn(false);
    setPeopleEmojiBtn(false);
    setAnimalEmojiBtn(false);
    setFoodEmojiBtn(false);
    setTravelEmojiBtn(true);
    setActivitiesEmojiBtn(false);
    setObjectsEmojiBtn(false);
    setSymbolsEmojiBtn(false);
    setFlagsEmojiBtn(false);
    setSearchEmojiQuery("");
  };
  const handleEmojiActivities = () => {
    setSmileyEmojiBtn(false);
    setPeopleEmojiBtn(false);
    setAnimalEmojiBtn(false);
    setFoodEmojiBtn(false);
    setTravelEmojiBtn(false);
    setActivitiesEmojiBtn(true);
    setObjectsEmojiBtn(false);
    setSymbolsEmojiBtn(false);
    setFlagsEmojiBtn(false);
    setSearchEmojiQuery("");
  };
  const handleEmojiObjects = () => {
    setSmileyEmojiBtn(false);
    setPeopleEmojiBtn(false);
    setAnimalEmojiBtn(false);
    setFoodEmojiBtn(false);
    setTravelEmojiBtn(false);
    setActivitiesEmojiBtn(false);
    setObjectsEmojiBtn(true);
    setSymbolsEmojiBtn(false);
    setFlagsEmojiBtn(false);
    setSearchEmojiQuery("");
  };
  const handleEmojiSymbols = () => {
    setSmileyEmojiBtn(false);
    setPeopleEmojiBtn(false);
    setAnimalEmojiBtn(false);
    setFoodEmojiBtn(false);
    setTravelEmojiBtn(false);
    setActivitiesEmojiBtn(false);
    setObjectsEmojiBtn(false);
    setSymbolsEmojiBtn(true);
    setFlagsEmojiBtn(false);
    setSearchEmojiQuery("");
  };

  const handleEmojiFlags = () => {
    setSmileyEmojiBtn(false);
    setPeopleEmojiBtn(false);
    setAnimalEmojiBtn(false);
    setFoodEmojiBtn(false);
    setTravelEmojiBtn(false);
    setActivitiesEmojiBtn(false);
    setObjectsEmojiBtn(false);
    setSymbolsEmojiBtn(false);
    setFlagsEmojiBtn(true);
    setSearchEmojiQuery("");
  };

  const convertTimeTo12HoursFormat = (timeString: string) => {
    const date = new Date(timeString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  return (
    <MainContainer>
      <Main
        style={{
          width: profileModal ? "100%" : "98%",
        }}
      >
        <Chat>
          <ChatNav>
            <div>
              <div>
                <FiChevronLeft
                  onClick={closeChat}
                  size={20}
                  style={{
                    cursor: "pointer",
                  }}
                />
              </div>
              <div onClick={handleProfileModal}>
                <img
                  src={data.image || "image/Default_Profile.png"}
                  alt="Avatar"
                />
                <span
                  style={{
                    width: profileModal ? "250px" : "",
                  }}
                >
                  {data.userName}
                </span>
              </div>
            </div>
            <div>
              <div onClick={closeChat}>
                <span>Close chat</span>
                <span>
                  <FiX />
                </span>
              </div>
              <div>
                <span>
                  <FiVideo />
                </span>
                <span>|</span>
                <span onClick={audioCallModal}>
                  <FiPhone />
                </span>
              </div>
              <div>
                <FiMoreVertical />
              </div>
            </div>
          </ChatNav>
          <ChatMessage ref={scrollContainerRef}>
            <BottomBtn
              onClick={scrollToBottom}
              style={{
                display: scrollPosition <= 300 ? "" : "none",
              }}
            >
              <FiChevronDown size={20} />
            </BottomBtn>
            <LockMsgDialog>
              <div>
                <p>today</p>
                <div>
                  <BiSolidLockAlt />
                  <span>
                    Messages and calls are secure & encrypted.
                    <br />
                    Screenshots will be disabled during this chat.
                  </span>
                </div>
              </div>
            </LockMsgDialog>
            {loading ? (
              <>
                <SenderMessage>
                  <div>
                    <span>Loading</span>
                    <span>00:00</span>
                  </div>
                </SenderMessage>
                <ReceiveMessage>
                  <div>
                    <span>Loading</span>
                    <span>00:00</span>
                  </div>
                </ReceiveMessage>
              </>
            ) : (
              <>
                {initialMessageData.conversations.map((msg, index) => {
                  if (msg.sender === myChatId) {
                    return (
                      <SenderMessage key={index}>
                        <div>
                          <span>{msg.message}</span>
                          <span>{convertTimeTo12HoursFormat(msg.time)}</span>
                        </div>
                      </SenderMessage>
                    );
                  } else {
                    return (
                      <ReceiveMessage key={index}>
                        <div>
                          <span>{msg.message}</span>
                          <span>{convertTimeTo12HoursFormat(msg.time)}</span>
                        </div>
                      </ReceiveMessage>
                    );
                  }
                })}
              </>
            )}
          </ChatMessage>
          {showEmoji && (
            <EmojiContainer ref={emojiContainerRef}>
              <EmojiSearch>
                <EmojiSearchBox>
                  <FiSearch />
                  <input
                    ref={emojiSearchRef}
                    type="text"
                    placeholder="Search Emoji"
                    value={searchEmojiQuery}
                    onChange={handleEmojiSearch}
                  />
                </EmojiSearchBox>
                {searchEmojiQuery && (
                  <>
                    {EmojiLoading ? (
                      <LoadingState />
                    ) : (
                      <>
                        {filteredEmojis.length === 0 ? (
                          <EmojiNotFound> Emoji Not Found</EmojiNotFound>
                        ) : (
                          <div>
                            {" "}
                            {filteredEmojis.map((emoji) => (
                              <span
                                key={emoji.unicode}
                                onClick={() =>
                                  handleEmojiClick(emoji.character)
                                }
                              >
                                <span
                                  role="img"
                                  title={emoji.character}
                                  aria-label={emoji.name}
                                >
                                  {emoji.character}
                                </span>
                              </span>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </EmojiSearch>

              {!searchEmojiQuery && (
                <>
                  {smileyEmojiBtn && (
                    <EmojiCategory>
                      <span>Smileys & Emotion</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {smileyEmotion.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                  {peopleEmojiBtn && (
                    <EmojiCategory>
                      <span>people & body</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {peopleBody.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                  {animalEmojiBtn && (
                    <EmojiCategory>
                      <span>animals & nature</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {animalsNature.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                  {foodEmojiBtn && (
                    <EmojiCategory>
                      <span>food & drink</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {foodDrink.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                  {travelEmojiBtn && (
                    <EmojiCategory>
                      <span>travel & places</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {travelPlaces.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                  {activitiesEmojiBtn && (
                    <EmojiCategory>
                      <span>activities</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {activities.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                  {objectsEmojiBtn && (
                    <EmojiCategory>
                      <span>objects</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {objects.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                  {symbolsEmojiBtn && (
                    <EmojiCategory>
                      <span>symbols</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {symbols.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                  {flagsEmojiBtn && (
                    <EmojiCategory>
                      <span>flags</span>
                      {EmojiLoading ? (
                        <LoadingState />
                      ) : (
                        <div>
                          {flags.map((emoji, index) => (
                            <div
                              key={index}
                              title={emoji}
                              onClick={() => handleEmojiClickSub(emoji)}
                            >
                              {emoji}
                            </div>
                          ))}
                        </div>
                      )}
                    </EmojiCategory>
                  )}
                </>
              )}

              <EmojiNavigator>
                <button title="Smileys & Emotion" onClick={handleEmojiSmiley}>
                  <PiSmiley />
                </button>
                <button title="People & Body" onClick={handleEmojiPeople}>
                  <PiHand />
                </button>
                <button title="Animals & Nature" onClick={handleEmojiAnimal}>
                  <PiDog />
                </button>
                <button title="Food & Drink" onClick={handleEmojiFood}>
                  <PiPizza />
                </button>
                <button title="Travel & Places" onClick={handleEmojiTravel}>
                  <PiCar />
                </button>
                <button title="Activities" onClick={handleEmojiActivities}>
                  <PiSoccerBall />
                </button>
                <button title="Objects" onClick={handleEmojiObjects}>
                  <PiShapes />
                </button>
                <button title="Symbols" onClick={handleEmojiSymbols}>
                  <PiDiamond />
                </button>
                <button title="Flags" onClick={handleEmojiFlags}>
                  <PiFlag />
                </button>
              </EmojiNavigator>
            </EmojiContainer>
          )}
          <ChatInputs>
            <InputContainer>
              <FiPlus size={22} color="#000" style={{ cursor: "pointer" }} />
              {showEmoji ? (
                <>
                  <PiKeyboard
                    size={22}
                    color="#000"
                    onClick={handleEmojiCancelVisibility}
                    style={{ cursor: "pointer" }}
                  />
                </>
              ) : (
                <PiSmiley
                  size={22}
                  color="#000"
                  onClick={handleEmojiVisibility}
                  style={{ cursor: "pointer" }}
                />
              )}
              <TextareaAutosize
                ref={textareaRef}
                placeholder="Message"
                value={message}
                onChange={handleTextChange}
                onKeyDown={handleKeyDown}
              />
              {/* <button onClick={toggleVolume}>
                Toggle Volume ({volume === 1 ? "Mute" : "Unmute"})
              </button> */}
              <ReactPlayer
                url="audios/sendSound.wav"
                playing={isPlaying}
                // volume={volume}
                style={{ display: "none" }}
              />
              {showSendButton ? (
                <div onClick={handleSendMessage}>
                  <BiPaperPlane size={18} color="#fff" />
                </div>
              ) : (
                <>
                  <FiCamera
                    size={22}
                    color="#000"
                    style={{ cursor: "pointer" }}
                  />
                  <FiMic size={22} color="#000" style={{ cursor: "pointer" }} />
                </>
              )}
            </InputContainer>
          </ChatInputs>
        </Chat>
      </Main>
      {profileModal && (
        <ProfileModal
          handleProfileModal={handleProfileModal}
          userName={data.userName}
          conversationId={newConversationId}
          userId={data.userId}
          avatar={data.image}
          closeFunc={closeChat}
        />
      )}
    </MainContainer>
  );
};

export default MessageChat;
